import React from "react";
import { FontAwesomeIcon } from "../shared/FontAwesomeIconWrapper";
import autoBind from "react-autobind";
import PlayerCheckbox from "./PlayerCheckbox";
import _ from "lodash";
import { branch } from "baobab-react/higher-order";

import { markdownToHtml } from "../../utils/markupUtils";
import withPlayerItemHoc from "./PlayerItemHoc";
import { getUrlForValue } from "../../actions/drive";
import { getSelectedActivityId, setNextItemChecked } from "../../actions/playerActions";
import DoneButton from "./DoneButton";
import { generateFluidFontSizeStyling } from "../../utils/utils";

/*
	 Generic read-only version of a player component 
 */
class PlayerItem extends React.PureComponent {

	constructor(props) {
		super(props);
		this.readOnly = false;
		this.showModeVideoRef = React.createRef();
		this.videoRef = React.createRef();
		autoBind(this);
	}

	onSubmit(event) {
		if (this.props.onSubmit) {
			const checked = this.props.item && this.props.item.labelOnly ? true : event.target.checked;
			// console.log("SUBMIT", checked);

			const
				{ listIndex, sectionIndex, itemIndex, identityId, disabled, item } = this.props;
			const { linkOnCheck, linkId, linkActionType } = item;

			this.props.onSubmit(
				{ checked, listIndex, sectionIndex, itemIndex, identityId, linkOnCheck, linkId, linkActionType, disabled });
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.selected === false && this.props.selected === true && this.props.showMode) {
			let video = _.get(this.showModeVideoRef, "current.video");
			if (!_.isUndefined(video) && video !== null) {
				video.pause();
				video.seek(0);
			}
		}
	}

	render() {
		console.log("RENDER ITEM", this.props.item.label1);
		if (this.props.showMode !== true) {
			if (this.props.readOnly) {
				return this.renderReadOnly();
			} else {
				return this.renderEditable();
			}
		} else {
			return this.renderShowMode();
		}
	}

	renderReadOnly() {
		const { item, getImage, getVideo, getPdf, selected } = this.props;

		let check;
		if (!(this.props.hasOwnProperty("showMode") && this.props.showMode) && !(this.props.item.labelOnly)) {
			if (item.checked) {
				check = <FontAwesomeIcon fixedWidth={true} style={{ fontSize: "32px", width: "32px", height: "32px", margin: 10 }} icon="check-square" />;
			} else {
				check = <FontAwesomeIcon fixedWidth={true} style={{ fontSize: "32px", width: "32px", height: "32px", margin: 10 }} icon="square" />;
			}
		}

		const { styleLabel1, styleLabel2 } = this.props.getLabelStyles();
		return (
			<div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
				<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
					{check}
					<div style={{ width: "100%" }}>
						<div style={styleLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1, { readOnlyLinks: true })} />
						<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2, { readOnlyLinks: true })} />							
						{getImage()}
						{getVideo(this.videoRef)}
						{getPdf()}
						{this.getImageComponent()}
					</div>
				</div>
				{item && item.labelOnly && selected && <DoneButton onSubmit={this.onSubmit} />}
			</div>
		);
	}

	renderEditable() {
		const { item, getImage, getVideo, getPdf, selected, listIndex, sectionIndex, itemIndex, disabled } = this.props;

		let check = <PlayerCheckbox className="player-item-checkbox-large" id={"player-check-item-" + this.props.getActivityItemPath("-")} disabled={disabled} checked={item.checked} item={item} onChange={this.onSubmit} checkedColor={this.props.checkedColor} />;
		const { styleLabel1, styleLabel2 } = this.props.getLabelStyles();
		return (
			<div style={{ display: "flex", flexDirection: "column", width: "100%" }}/* onClick={(e)=>{e.stopPropagation();this.props.dispatch(setNextItemChecked);}}*/>

				<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
					<div>
						{check}
					</div>
					<div style={{ width: "100%" }}>
						<div onClick={(e)=>{e.stopPropagation();this.props.dispatch(setNextItemChecked);}}>
							<div style={styleLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1, { listIndex, sectionIndex, itemIndex })} />
							<div style={styleLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2, { listIndex, sectionIndex, itemIndex })} />
						</div>	
						{getImage()}
						{getVideo(this.videoRef)}
						{getPdf()}
						{/* {this.getImageComponent()} */}
					</div>
				</div>
				<div style={{width: "100%"}} onClick={(e)=>{e.stopPropagation();this.props.dispatch(setNextItemChecked);}}>
					{item && item.labelOnly && selected && !disabled && !this.props.isStartOfGroup && <DoneButton onSubmit={this.onSubmit} />}
				</div>
			</div>
		);
	}

	renderShowMode() {
		const { item, showModeTextAlign: _showModeTextAlign, useCustomShowModeStyling } = this.props;
		// // console.log("Deternine background image", this.props);
		let backgroundImage;
		if (item.backgroundImage) {
			const url = getUrlForValue(item.backgroundImage, getSelectedActivityId());
			backgroundImage = `url(${url})`;
		}

		let mediaItem;

		let image = this.props.getImageShowMode();
		let video = this.props.getVideoShowMode(this.showModeVideoRef);

		if (image) {
			mediaItem = image;
		} else if (video) {
			mediaItem = video;
		}

		const hasTextContent = (item.label1 && !_.isEmpty(item.label1)) || (item.label2 && !_.isEmpty(item.label2));

		const { showModeTextAlign } = item;

		let align = "";
		if (showModeTextAlign || _showModeTextAlign) {

			const targetShowModeTextAlign = showModeTextAlign ? showModeTextAlign : _showModeTextAlign;

			align = " " + targetShowModeTextAlign.split("-").join(" ");
		}

		const { styleLabel1, styleLabel2 } = this.props.getLabelStyles(false);
		let additionalPropsLabel1 = {};
		let additionalPropsLabel2 = {};
		if (useCustomShowModeStyling === true) {
			const label1FluidFontStyle = generateFluidFontSizeStyling(styleLabel1, .5, "calc(20px + (36 - 20) * ((100vw - 300px) / (1600 - 300)))");
			additionalPropsLabel1.style = styleLabel1 ? _.cloneDeep(styleLabel1) : {};
			additionalPropsLabel1.style.fontSize = label1FluidFontStyle;


			const label2FluidFontStyle = generateFluidFontSizeStyling(styleLabel2, .5, "calc(16px + (30 - 16) * ((100vw - 300px) / (1600 - 300)))");
			additionalPropsLabel2.style = styleLabel2 ? _.cloneDeep(styleLabel2) : {};
			additionalPropsLabel2.style.fontSize = label2FluidFontStyle;
		}

		return (<div style={{
			display: "flex", flexDirection: "column", width: "100%", height: "100%", backgroundImage: backgroundImage, backgroundPosition: "center", backgroundSize: "cover", backgroundRepeat: "noRepeat"
		}}>
			<div className="player-show-mode-view" style={{ display: "flex", width: "100%", height: "100%", padding: "20px 40px 40px 40px", boxSizing: "border-box" }}>

				{hasTextContent && <div className="player-show-mode-text-item-container">
					{(window.innerWidth*window.innerHeight <= 200000) &&
					<div className={`player-show-mode-label-item-container${align}`}>
						<h5 {...additionalPropsLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1)} />
						<h6 {...additionalPropsLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2)} />
					</div>
					}
					{(window.innerWidth*window.innerHeight > 200000 && window.innerWidth*window.innerHeight <= 300000) &&
					<div className={`player-show-mode-label-item-container${align}`}>
						<h4 {...additionalPropsLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1)} />
						<h5 {...additionalPropsLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2)} />
					</div>
					}
					{(window.innerWidth*window.innerHeight > 300000 && window.innerWidth*window.innerHeight <= 360000) &&
					<div className={`player-show-mode-label-item-container${align}`}>
						<h3 {...additionalPropsLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1)} />
						<h4 {...additionalPropsLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2)} />
					</div>
					}
					{(window.innerWidth*window.innerHeight > 360000) &&
					<div className={`player-show-mode-label-item-container${align}`}>
						{/* <p>{window.innerHeight + "; " + window.innerWidth}</p> */}
						<h2 {...additionalPropsLabel1} dangerouslySetInnerHTML={markdownToHtml(item.label1)} />
						<h3 {...additionalPropsLabel2} dangerouslySetInnerHTML={markdownToHtml(item.label2)} />
					</div>
					}
				</div>}
				{mediaItem && <div className="player-show-mode-media-item-container">
					<div>{mediaItem}</div>
				</div>}
			</div>
		</div>);
	}



	getImageComponent() {
		const item = this.props.item;

		let imageComponent;
		if (item.hasOwnProperty("sketchPadImage") && item.sketchPadImage !== null && item.sketchPadImage !== "") {
			const imgUrl = "<p><b>Sketch</b><br/><a href='" + item.sketchPadImage + "' target='blank'><img style='width: 30%; border: 1px solid #eeeeee' src='" + item.sketchPadImage + "' /></a></p>";
			imageComponent =
				<div dangerouslySetInnerHTML={markdownToHtml(imgUrl)} />;
		}
		return imageComponent;
	}
	handleStateChange(state, prevState) {
		const self = this;
		// copy player state to this component's state
		if (state.isFullscreen !== prevState.isFullscreen) {
			this.videoRef.current.muted = !state.isFullscreen;
		}

		// Close full screen if get to end
		if (state.isFullscreen && state.ended && !prevState.ended) {
			this.videoRef.current.toggleFullscreen();
			setTimeout(function () {
				self.videoRef.current.play();
			}, 1000);
		}

		// when not in fullscreen, keep repeating
		if (!state.isFullscreen && state.ended && !prevState.ended) {
			this.videoRef.current.play();
		}
	}
	componentDidMount() {
		if (this.videoRef && this.videoRef.current && this.videoRef.current.subscribeToStateChange) {
			this.videoRef.current.subscribeToStateChange(this.handleStateChange.bind(this));
		}
	}
}

export default branch({
	checkedColor: ["appPreferences", "checkedColor"]
}, withPlayerItemHoc(PlayerItem));